@if (isMobile.matches) {
  <app-translate-mobile />
} @else {
  <app-translate-desktop />
}
